import defaultApi from '@/utils/request';

export default {
  // 加載列表
  // ============================== S49W2001 ==================================
  // S49W2001 處理台企銀銀行自動銷帳作業
  S49W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W2001_Load',
      params,
    });
  },
  S49W2001_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W2001_Query',
      params,
    });
  },
  // =======================================================================================
  S49W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W4001_Load',
      params,
    });
  },
  S49W4001_Get_PrtPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W4001_Get_PrtPDF',
      responseType: 'blob',
      params,
    });
  },
  S49W4001_QueryBarcode(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W4001_QueryBarcode',
      params,
    });
  },

  // =======================================================================================
  S49W4002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W4002_Load',
      params,
    });
  },

  S49W4002_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W4002_Query',
      params,
    });
  },

  // =======================================================================================
  S49W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W4003_Load',
      params,
    });
  },
  S49W4003_PreQuery(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W4003_PreQuery',
      params,
    });
  },
  S49W4003_Get_PrtPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W4003_Get_PrtPDF',
      responseType: 'blob',
      params,
    });
  },
  // ============================== S49W4004 ==================================
  // S49W4004 歷年學雜費繳費狀況
  S49W4004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S49/S49W4004_Load',
      params,
    });
  },
};
